module.exports = __webpack_public_path__ + "static/media/MaisonNeue-MediumItalic.62978e57.otf";